"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.LogoLink = exports.LogoImage = exports.DropdownText = exports.Dropdown = exports.NavWrapper = exports.DropdownWrapper = exports.Wrapper = exports.HeaderContainer = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _mediaQueries = _interopRequireDefault(require("../../../styles/mediaQueries"));

var _Typography = require("../../Typography");

var _Layout = require("../../Layout");

var _sharedStyle = require("../../../styles/sharedStyle");

var _Link = _interopRequireDefault(require("../../Link"));

var HeaderContainer = (0, _styled.default)(_Layout.Container)({
  display: 'flex',
  justifyContent: 'space-between',
  position: 'relative',
  alignItems: 'center',
  overflow: 'hidden',
  '> *': {
    zIndex: '1'
  },
  '> a:nth-of-type(2)': {
    // IE fix
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      order: '3',
      flex: '0 0 auto'
    }
  }
});
exports.HeaderContainer = HeaderContainer;
var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      header = _ref$theme.header;
  return {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    minHeight: header.primary.height,
    height: '100%',
    borderBottom: header.primary.border === 'none' ? header.border : "1px solid ".concat(colors[header.primary.border]),

    /* Microsoft IE10 and above */
    '@media all and (-ms-high-contrast: none)': {
      height: header.primary.height
    },
    background: colors[header.primary.background]
  };
});
exports.Wrapper = Wrapper;
var DropdownWrapper = (0, _styled.default)('div')(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      header = _ref2$theme.header,
      isNavOpen = _ref2.isNavOpen;
  return _defineProperty({
    display: 'flex',
    position: 'absolute',
    left: '0',
    visibility: isNavOpen ? 'visible' : 'hidden',
    opacity: isNavOpen ? '1' : '0',
    transition: 'visible 0.2s ease-in-out, opacity 0.2s ease-in-out',
    background: colors.offwhite,
    height: 'calc(100vh - 120px)',
    width: '100%',
    flexDirection: 'column',
    top: header.primary.height,
    overflowY: 'auto',
    overflowX: 'hidden',
    zIndex: '10'
  }, _mediaQueries.default[header.primary.breakpoint], {
    display: 'block',
    left: 'initial',
    top: 'initial',
    background: 'initial',
    height: 'initial',
    width: 'initial'
  });
});
exports.DropdownWrapper = DropdownWrapper;
var NavWrapper = (0, _styled.default)('div')(function (_ref4) {
  var _ref5;

  var header = _ref4.theme.header;
  return _ref5 = {
    order: '1'
  }, _defineProperty(_ref5, _mediaQueries.default[header.primary.breakpoint], {
    display: 'flex',
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: '0',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }), _defineProperty(_ref5, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
    position: 'relative',
    order: '2'
  }), _ref5;
});
exports.NavWrapper = NavWrapper;
var Dropdown = (0, _styled.default)('div')(function (_ref6) {
  var _ref7;

  var _ref6$theme = _ref6.theme,
      space = _ref6$theme.space,
      colors = _ref6$theme.colors,
      header = _ref6$theme.header,
      isNavOpen = _ref6.isNavOpen;
  return _ref7 = {
    color: isNavOpen ? colors[header.primary.background] : colors[header.primary.foreground],
    display: 'flex',
    height: '100%',
    cursor: 'pointer',
    minHeight: header.primary.height,
    padding: "0 ".concat(space.base),
    alignItems: 'center',
    marginRight: "-".concat(space.base),
    background: isNavOpen ? colors.offwhite : 'transparent',
    transition: 'background 0.2s ease-in-out',
    willChange: 'background'
  }, _defineProperty(_ref7, _mediaQueries.default.small, {
    marginRight: "-".concat(space.base)
  }), _defineProperty(_ref7, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
    height: '0'
  }), _ref7;
});
exports.Dropdown = Dropdown;
var DropdownText = (0, _styled.default)(_Typography.Body)(function (_ref8) {
  var _ref8$theme = _ref8.theme,
      fonts = _ref8$theme.fonts,
      colors = _ref8$theme.colors,
      header = _ref8$theme.header,
      isNavOpen = _ref8.isNavOpen;
  return _objectSpread({
    fontFamily: fonts.body
  }, (0, _sharedStyle.textHover)({
    color: isNavOpen ? colors.greydark : colors[header.primary.foreground],
    active: false,
    weight: 'bold',
    width: '2px'
  }));
});
exports.DropdownText = DropdownText;
var LogoImage = (0, _styled.default)(_rebass.Image)({
  display: 'block',
  width: 'auto'
});
exports.LogoImage = LogoImage;
var LogoLink = (0, _styled.default)(_Link.default)({
  // IE fix
  '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
    order: '1'
  },
  img: {
    height: 'auto',
    width: '100%',
    '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 576px)': {
      width: 'auto'
    }
  }
});
exports.LogoLink = LogoLink;